module.exports = __webpack_public_path__ + "static/media/arrow-alt-from-left.6aec4633.svg";